import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { useHelpers, useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useRoute } from 'vue-router'
import { useAuth } from '@/entities/Auth'

export const useSendForm = () => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()
  const route = useRoute()
  const queryClient = useQueryClient()
  const { user } = useAuth()
  const { getDifferentObject } = useHelpers()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      return http.put(`/cabinets/${route.params.object_id}/admin/main`, data)
    },
  })

  const sendForm = async (data: any, origin: any, valid: boolean) => {
    if (!valid) return

    try {
      /* Преобразуем координаты в из строки в число */
      data = {
        ...data,
        longitude: Number(data.longitude),
        latitude: Number(data.latitude),
      }

      /** Проверка на наличие измененных данных */
      const diffData = getDifferentObject(origin, data)
      if (!Object.keys(diffData).length) return

      await mutation.mutateAsync(diffData)

      await queryClient.fetchQuery({ queryKey: ['load_cabinet', route.params.object_id] })

      if (user?.object_group.id === data.parent_id) {
        await queryClient.fetchQuery({ queryKey: ['load_tree', 'default'] })
      } else if (data.old_parent_id && data.parent_id != data.old_parent_id) {
        await queryClient.fetchQuery({ queryKey: ['load_tree', data.old_parent_id] })
      } else {
        await queryClient.fetchQuery({ queryKey: ['load_tree', data.parent_id] })
      }

      addSuccess(trs('itf.saved'))
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    sendForm,
  }
}
